import { render, staticRenderFns } from "./acesso.vue?vue&type=template&id=507bf3c6"
import script from "./acesso.vue?vue&type=script&lang=js"
export * from "./acesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports